<div class="main-configuracao-view" *ngIf="gridMode">
    
    <div class="dialog_scrim" *ngIf="openMenu">
    </div>

    <button mat-mini-fab color="accent" (click)="clickMenu()"
        class="float-button"
        [class.mat-elevation-z2]="!isOver"
        [class.mat-elevation-z8]="isOver"
        (mouseover)="isOver = true"
        (mouseleave)="isOver = false">
        <mat-icon *ngIf="!openMenu">menu</mat-icon>
        <mat-icon *ngIf="openMenu">close</mat-icon>
    </button>

    <button mat-mini-fab  [disabled]="!canInsert"
        class="float-button two mat-elevation-z8"    
        *ngIf="openMenu"
        color="success"
        (click)="addNewItem()">
        <mat-icon>add</mat-icon>
    </button>

    <button mat-mini-fab [disabled]="!canView"
        class="float-button one mat-elevation-z8"    
        *ngIf="openMenu"
        color="primary" 
        (click)="refresh()">
        <mat-icon>refresh</mat-icon>
    </button>
    
    <mat-slide-toggle [(ngModel)]="userConfig.workRefresh" labelPosition="before" (ngModelChange)="onChangeWorkRefresh()"
    class="float-button three mat-elevation-z8" 
    *ngIf="openMenu"  >
        Atualização da Rota
    </mat-slide-toggle>

    <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='main-card-view'>
    </ngx-spinner>
    <div class="main-grid-view-filter">
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <mat-accordion class="accordion-align-header" >
            <mat-expansion-panel (afterExpand)="recalculateView(widthScrollContainer)" (afterCollapse)="recalculateView(widthScrollContainer)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Filtro
                </mat-panel-title>
                <mat-panel-description>
                  Preencher com o filtro desejado
                  <mat-icon [color]="filterColor">filter_alt</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>
                <div class="grid">
                    <div class="line">
                        <div class="column4">
                            <mat-form-field class="no-padding-form-field full-width"> 
                                    <input matInput [formControl]="inputFilter" (keyup)="updateFilter($event)" placeholder="Ex: Integração de Pedidos">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="line">
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterStatus)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Status</mat-label>
                                <mat-select [formControl]="filterStatus" multiple>
                                <mat-option *ngFor="let item of statusList" [value]="item.key">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterActive)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Ativo</mat-label>
                                <mat-select [formControl]="filterActive" multiple>
                                <mat-option *ngFor="let item of activeList" [value]="item.key">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterCompany)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Contexto</mat-label>
                                <mat-select [formControl]="filterCompany" multiple>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Buscar..." 
                                        noEntriesFoundLabel="'Dados não encontrado'" 
                                        ngModel (ngModelChange)="filterOptions($event,false,'companyList')"
                                        [ngModelOptions]="{standalone: true}"
                                        [preventHomeEndKeyPropagation]="true">
                                            <mat-icon ngxMatSelectSearchClear (click)="filterOptions('',true,'companyList')">delete</mat-icon>
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let item of companyListFiltered" [value]="item.key">{{item.key}} - {{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterMulti)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Multiplos Contextos</mat-label>
                                <mat-select [formControl]="filterMulti" multiple>
                                <mat-option *ngFor="let item of multiList" [value]="item.key">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="line">
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterMarketplace)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>MarketPlace</mat-label>
                                <mat-select [formControl]="filterMarketplace" multiple>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Buscar..." 
                                        noEntriesFoundLabel="'Dados não encontrado'" 
                                        ngModel (ngModelChange)="filterOptions($event,false,'marketPlaceList')"
                                        [ngModelOptions]="{standalone: true}"
                                        [preventHomeEndKeyPropagation]="true">
                                            <mat-icon ngxMatSelectSearchClear (click)="filterOptions('',true,'marketPlaceList')">delete</mat-icon>
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let item of marketPlaceListFiltered" [value]="item.key">{{item.key}} - {{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterTipo)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Tipo Integração</mat-label>
                                <mat-select [formControl]="filterTipo" multiple>
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Buscar..." 
                                        noEntriesFoundLabel="'Dados não encontrado'" 
                                        ngModel (ngModelChange)="filterOptions($event,false,'typeList')"
                                        [ngModelOptions]="{standalone: true}"
                                        [preventHomeEndKeyPropagation]="true">
                                            <mat-icon ngxMatSelectSearchClear (click)="filterOptions('',true,'typeList')">delete</mat-icon>
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let item of typeListFiltered" [value]="item.key">{{item.key}} - {{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column">
                            <mat-form-field class="no-padding-form-field" [matBadge]="getBadge(filterServer)" matBadgeColor="warn" matBadgePosition="after">
                                <mat-label>Servidor</mat-label>
                                <mat-select [formControl]="filterServer" multiple>
                                <mat-option *ngFor="let item of serverList" [value]="item.key">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <mat-divider></mat-divider>
    <div class="scroll-container" #scrollcontainer  (window:resize)="onResize($event)">
        <li-virtual-scroll   [items]="mktpcfg" [gridList]="true" class="scroll-container-item" >
            <mat-card appearance="outlined" class="card-config" *liVirtualItem="let item" [ngStyle]="{'min-width.px':width, 'max-width.px':width, 'width.px':width}">
                <mat-card-header>
                    <mat-card-title class="header-title-card">
                        <span class="title-card"  [matTooltip]="item['NAME']" matTooltipClass="toolTip-request">{{item['IDCONF']}} - {{item['NAME']}}</span>
                        <div fxFlex></div>
                        <mat-icon color="accent" matTooltip="Rota para múltiplos contextos" matTooltipClass="toolTip-request" *ngIf="item['MULTI'] == 'S'">library_add</mat-icon>
                    </mat-card-title>
                    <mat-card-subtitle>{{status}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                <p *ngIf="item['MULTI']=='N'">{{item['DATA'][0]['CODECOMPANY']}}- {{item['DATA'][0]['CODECOMPANY_NAME']}}</p>
                <p>{{item['CODEMKTP']}} - {{item['CODEMKTP_NAME']}}</p>
                <p>{{item['IDTPI']}}- {{item['IDTPI_NAME']}}</p>
                <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-actions>
                    <div class="item-actions">
                        <button mat-button (click)="editarDados(item,false)" *ngIf="canEdit">Editar</button>
                        <div fxFlex></div>
                        <mat-slide-toggle [(ngModel)]="item['activeBOO']" (ngModelChange)="itemChange(item)" >
                        </mat-slide-toggle>
                        <mat-divider [vertical]="true"  class="divider2"></mat-divider>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openContext($event,item)" *ngIf="item['MULTI']=='S'">
                                <mat-icon  color="primary">library_add</mat-icon>
                                <span>Contextos</span>
                            </button>
                            <button mat-menu-item (click)="executeEvent($event,item)">
                                <mat-icon  color="primary">bolt</mat-icon>
                                <span>Executar</span>
                            </button>
                            <button mat-menu-item (click)="openLog($event,item)">
                                <mat-icon color="primary">history</mat-icon>
                                <span>Log</span>
                            </button>
                            <button mat-menu-item (click)="kill($event,item)">
                                <mat-icon color="warn">stop_cricle</mat-icon>
                                <span>Interromper Execução</span>
                            </button>
                        </mat-menu>
                    </div>
                </mat-card-actions>
                <mat-card-footer>
                <mat-progress-bar [mode]="item.barMode" [color]="item.barColor" [value]="item.barValue" [matTooltip]="getStatusName(item)" matTooltipClass="toolTip-request"></mat-progress-bar>
                </mat-card-footer>
            </mat-card>
        </li-virtual-scroll>
      </div>
      <div class="summary">
        <div class="totalLines">Total de Linhas: {{ mktpcfg_temp.length }}</div>
        <span class="spacer"></span>
        <div class="lines">Linhas: {{ mktpcfg.length }} </div>
      </div>
</div>
<div class="editMode"  *ngIf="!gridMode" >
    <mat-toolbar>
        <mat-toolbar-row>
            <button mat-mini-fab  matTooltip="Voltar"  (click)="gridMode=true" > 
                <mat-icon  aria-hidden="false" >reply</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <wizard-configuracao [insert]="insert" [data]="data" (saving)="wizardChange($event)"></wizard-configuracao>
</div>
